<template>
    <div>
        <div class="registration-section__title">
            <span>{{ $t('create account') | capitalize }}</span>
            <span class="registration-section__title-info">~2 min</span>
        </div>
        <div class="registration-section__form-group--basic">
            <div class="registration-section__form-group-title">
                {{ $t('Your basic info so we know who you are')}}.
            </div>
            <div class="registration-section__form-group-inputs">
                <CustomInput
                    name="firstName"
                    :value="firstName"
                    label="first name"
                    :errorMessage="errors.firstName"
                    @input="$emit('update:firstName', $event)"
                    @valueChanged="$listeners.valueChanged"
                    @blur="$listeners.blur"
                />
                <CustomInput
                    name="lastName"
                    :value="lastName"
                    label="last name"
                    :errorMessage="errors.lastName"
                    @input="$emit('update:lastName', $event)"
                    @valueChanged="$listeners.valueChanged"
                    @blur="$listeners.blur"
                />

            </div>
        </div>
        <div class="registration-section__form-group--account">
            <div class="registration-section__form-group-title">
                {{ $t('Info for contacting you. Enables you to effortlesly access your funds,' +
                    ' account settings and our support') }}
            </div>
            <div class="registration-section__form-group-inputs">
                <CustomInput
                    name="email"
                    :value="email"
                    label="E-mail"
                    :errorMessage="errors.email"
                    @input="$emit('update:email', $event)"
                    @valueChanged="$listeners.valueChanged"
                    @blur="$listeners.blur"
                />
                <CustomInput
                    name="username"
                    :value="username"
                    label="username"
                    :errorMessage="errors.username"
                    @input="$emit('update:username', $event)"
                    @valueChanged="$listeners.valueChanged"
                    @blur="$listeners.blur"
                />
                <Password
                    name="password"
                    :value="password"
                    label="password"
                    :errorMessage="errors.password"
                    :shouldAutoFill="false"
                    @input="$emit('update:password', $event)"
                    @valueChanged="$listeners.valueChanged"
                    @blur="$listeners.blur"
                />
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            firstName: {
                type: String,
                required: true,
            },
            lastName: {
                type: String,
                required: true,
            },
            email: {
                type: String,
                required: true,
            },
            username: {
                type: String,
                required: true,
            },
            password: {
                type: String,
                required: true,
            },
            errors: {
                type: Object,
                required: true,
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/authentication/components/register/BasicInfo.vue